(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inline-filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const closeOnOutsideClick = (event) => {
      document.querySelectorAll('.inline-filters__dropdown[open]').forEach((details) => {
        if (!details.contains(event.target)) details.removeAttribute('open');
      });
    };
    document.addEventListener('click', closeOnOutsideClick);

    document.querySelectorAll('.inline-filters').forEach((form) => {
      const dataEl = form.querySelector('[data-inline-filters-data]');
      if (!dataEl) return;

      let products;
      try {
        products = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      const checkedValues = (group) =>
        Array.from(form.querySelectorAll(`li[data-filter-group="${group}"] input[type="checkbox"]:checked`)).map(
          (input) => input.value
        );

      const countFor = (group, value, otherGroup, otherSelected) => {
        const key = group === 'vendor' ? 'v' : 't';
        const otherKey = otherGroup === 'vendor' ? 'v' : 't';
        let count = 0;
        for (const product of products) {
          if (product[key] !== value) continue;
          if (otherSelected.length && !otherSelected.includes(product[otherKey])) continue;
          count++;
        }
        return count;
      };

      const updateGroup = (group, otherGroup) => {
        const otherSelected = checkedValues(otherGroup);
        const items = form.querySelectorAll(`li[data-filter-group="${group}"]`);
        let checkedCount = 0;
        items.forEach((li) => {
          const input = li.querySelector('input[type="checkbox"]');
          const labelSpan = li.querySelector('.checkbox__label-text');
          if (!input || !labelSpan) return;
          if (input.checked) checkedCount++;
          const count = countFor(group, li.dataset.filterValue, otherGroup, otherSelected);
          labelSpan.textContent = `${li.dataset.baseLabel} (${count})`;
          input.disabled = count === 0 && !input.checked;
        });
        const dropdown = form.querySelector(`li[data-filter-group="${group}"]`)?.closest('.inline-filters__dropdown');
        const countBadge = dropdown?.querySelector('.inline-filters__dropdown-count');
        if (countBadge) countBadge.hidden = checkedCount === 0;
        if (countBadge) countBadge.textContent = `(${checkedCount})`;
      };

      form.addEventListener('change', (event) => {
        const li = event.target.closest('li[data-filter-group]');
        if (!li) return;
        // Refresh both: the other group's availability/counts genuinely
        // depend on this change, and this group's own "(N) selected"
        // badge needs to reflect the click too.
        updateGroup('vendor', 'type');
        updateGroup('type', 'vendor');
      });

      updateGroup('vendor', 'type');
      updateGroup('type', 'vendor');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
